.container {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

/* Gray eyebrow label, mirrors the "Contact Info" section label on the contact card,
   so it reads as "this heading is the program you're QC'ing against." */
.programLabel {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--gray-text);
  opacity: 0.6;
}

.wrap {
  position: relative;
  margin: 0;
}

.title {
  font-size: 22px;
  font-weight: 600;
  color: var(--text);
  margin: 0;
}

/* Trigger looks like a plain heading; the chevron is the only switch affordance. */
.trigger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  color: inherit;
  font: inherit;
}

.chevron {
  font-size: 15px;
  color: var(--gray-text);
  transition: transform 0.15s ease;
  line-height: 1;
}

.chevronOpen {
  transform: rotate(180deg);
}

.menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 20;
  min-width: 220px;
  margin: 0;
  padding: 4px;
  list-style: none;
  background: var(--white);
  border: 1px solid var(--gray-border);
  border-radius: var(--radius);
  box-shadow: 0 4px 16px var(--shadow, #0000001a);
}

.option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 8px 10px;
  background: none;
  border: none;
  border-radius: calc(var(--radius) - 2px);
  cursor: pointer;
  font-size: 14px;
  color: var(--text);
  text-align: left;
}

.option:hover {
  background: var(--gray-bg);
}

.optionActive {
  font-weight: 600;
}

.check {
  color: var(--blue-light);
  font-size: 12px;
}
